/**
 * 门店选择表格配置 - 用于 BaseListManagement
 */
export const storeSelectTableConfig = ({ apiFn, handleSelectionChange }) => ({
  isShowDepartment: false,
  formData: {
    formProps: {
      model: {
        name: '',
      },
    },
    list: [
      {
        el: 'input',
        itemConfig: {
          label: '',
          prop: 'name',
        },
        elConfig: {
          placeholder: '搜索门店名称',
          clearable: true,
          style: 'width: 240px',
        },
      },
    ],
  },
  tableData: {
    apiFn,
    attrs: {
      'row-key': 'id', // 必须指定 row-key 才能让 reserveSelection 生效
    },
    events: {
      'selection-change': handleSelectionChange,
    },
    columns: [
      {
        name: 'selection',
        columnProps: {
          prop: 'selection',
          type: 'selection',
          width: 55,
          reserveSelection: true, // 开启跨页选择保持
        },
      },
      {
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '门店ID',
          width: 100,
        },
      },
      {
        name: 'cityName',
        columnProps: {
          prop: 'cityName',
          label: '城市',
          width: 100,
        },
      },
      {
        name: 'name',
        columnProps: {
          prop: 'name',
          label: '门店名称',
          minWidth: 180,
          showOverflowTooltip: true,
        },
      },
      {
        name: 'address',
        columnProps: {
          prop: 'address',
          label: '门店地址',
          minWidth: 200,
          showOverflowTooltip: true,
        },
      },
      {
        name: 'contactTel',
        columnProps: {
          prop: 'contactTel',
          label: '联系方式',
          width: 140,
        },
      },
    ],
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pagerCount: 5,
    },
  },
})
